import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=5c216ad6&scoped=true"
import script from "./LogDetails.vue?vue&type=script&lang=js"
export * from "./LogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c216ad6",
  null
  
)

export default component.exports